import type { interfaces } from "inversify";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import LustrationConfirmationViewModel from "./lustrationConfirmationViewModel";

export default class LustrationReportsFinishedViewModel extends LustrationConfirmationViewModel {
  constructor(public localizationService: LocalizationService) {
    super(localizationService);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `lustrationReports.finishedModal.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return () => new LustrationReportsFinishedViewModel(container.get(LocalizationService));
  }
}
